import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantEditEmploymentPage = {
  alert: {
    error: 'applicant-edit-employment-page.alert.error',
  },
  footer: {
    root: 'applicant-edit-employment-page.footer.root',
  },
  form: {
    cancelButton: 'applicant-edit-employment-page.form.cancel-button',
    employerNameInput:
      'applicant-edit-employment-page.form.employer-name-input',
    employerNameInputError:
      'applicant-edit-employment-page.form.employer-name-input-error',
    employmentDurationSelect:
      'applicant-edit-employment-page.form.employment-duration-select',
    employmentDurationSelectError:
      'applicant-edit-employment-page.form.employment-duration-select-error',
    employmentStatusSelect:
      'applicant-edit-employment-page.form.employment-status-select',
    employmentStatusSelectError:
      'applicant-edit-employment-page.form.employment-status-select-error',
    employmentTypeSelect:
      'applicant-edit-employment-page.form.employment-type-select',
    employmentTypeSelectError:
      'applicant-edit-employment-page.form.employment-type-select-error',
    grossAnnualIncomeInput:
      'applicant-edit-employment-page.form.gross-annual-income-input',
    grossAnnualIncomeInputError:
      'applicant-edit-employment-page.form.gross-annual-income-input-error',
    h1: 'applicant-edit-employment-page.form.h1',
    h2: 'applicant-edit-employment-page.form.h2',
    jobTitleInput: 'applicant-edit-employment-page.form.job-title-input',
    jobTitleInputError:
      'applicant-edit-employment-page.form.job-title-input-error',
    previousEmployerNameInput:
      'applicant-edit-employment-page.form.previous-employer-name-input',
    previousEmployerNameInputError:
      'applicant-edit-employment-page.form.previous-employer-name-input-error',
    previousEmploymentGrossAnnualIncomeInput:
      'applicant-edit-employment-page.form.previous-employment-gross-annual-income-input',
    previousEmploymentGrossAnnualIncomeInputError:
      'applicant-edit-employment-page.form.previous-employment-gross-annual-income-input-error',
    previousEmploymentH3:
      'applicant-edit-employment-page.form.previous-employment-h3',
    previousEmploymentJobTitleInput:
      'applicant-edit-employment-page.form.previous-employment-job-title-input',
    previousEmploymentJobTitleInputError:
      'applicant-edit-employment-page.form.previous-employment-job-title-input-error',
    previousEmploymentRoot:
      'applicant-edit-employment-page.form.previous-employment-root',
    previousEmploymentTypeSelect:
      'applicant-edit-employment-page.form.previous-employment-type-select',
    previousEmploymentTypeSelectError:
      'applicant-edit-employment-page.form.previous-employment-type-select-error',
    root: 'applicant-edit-employment-page.form.root',
    submitButton: 'applicant-edit-employment-page.form.submit-button',
    unemploymentGrossAnnualIncomeInput:
      'applicant-edit-employment-page.form.unemployment-gross-annual-income-input',
    unemploymentGrossAnnualIncomeInputError:
      'applicant-edit-employment-page.form.unemployment-gross-annual-income-input-error',
    unemploymentTypeSelect:
      'applicant-edit-employment-page.form.unemployment-type-select',
    unemploymentTypeSelectError:
      'applicant-edit-employment-page.form.unemployment-type-select-error',
  },
} as const satisfies PageLocatorMap;
